export default __webpack_public_path__ + "static/media/Flag_of_Kenya.bd24673f.svg";